export const courseCategories = [
  {
    name: 'Healthcare Management',
    items: [
      'Leadership in Healthcare',
      'Financial Management in Healthcare',
      'Value-Based Care Models',
    ],
  },
  {
    name: 'Clinical Care and Operations',
    items: [
      'Clinical Workflow Optimization',
      'Quality Assurance in Care',
      'Documentation Best Practices',
    ],
  },
  {
    name: 'Digital Health',
    items: [
      'Mobile Health Solutions',
      'Remote Patient Monitoring',
      'Telehealth Platforms',
      'Digital Therapeutics',
    ],
  },
  {
    name: 'Medical Research and Development',
    items: ['Drug Discovery and Design', 'Clinical Trial Management'],
  },
  {
    name: 'Patient Care',
    items: [
      'Patient-Centered Care',
      'Care Coordination',
      'Chronic Disease Management',
      'Mental Health Integration',
    ],
  },
  {
    name: 'Healthcare Data and Analytics',
    items: [
      'Data-Driven Decision Making',
      'Predictive Analytics in Care',
      'Population Health Management',
      'Cybersecurity in Health Data',
    ],
  },
  {
    name: 'Medical Devices',
    items: [
      'Wearable Medical Devices',
      'Connected Health Systems',
      'Regulatory Compliance for Devices',
      'IoT in Healthcare',
    ],
  },
  {
    name: 'Health Informatics',
    items: [
      'Electronic Health Records (EHR)',
      'Health Information Exchange',
      'Interoperability Solutions',
      'Big Data in Healthcare',
    ],
  },
  {
    name: 'Healthcare Policy and Regulations',
    items: [
      'Global Health Policies',
      'Healthcare Compliance',
      'Medical Ethics',
      'Health Equity Initiatives',
    ],
  },
  {
    name: 'AI in Healthcare',
    items: [
      'AI in Diagnostics',
      'AI for Predictive Models in Healthcare',
      'Introduction to Medical Computer Vision',
    ],
  },
  {
    name: 'Bioinformatics',
    items: [
      'Introduction to Bioinformatics',
      'Genomics Research',
      'Computational Biology Tools',
    ],
  },
];
